(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38],{

/***/ 3313:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[wpTag]/[slug]",
      function () {
        return __webpack_require__(2663);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppFooter */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);



var AppFooter = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer_container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer_about",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_us",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_logo",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/boom_logo.png",
                                alt: "Boom logo",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_info",
                            children: "Copyright \xa9 2021, BoomTV"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_links",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Terms and Conditions"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Privacy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/about",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/personal-data",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Do Not Sell My Personal Information"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppFooter);


/***/ }),

/***/ 9735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5617);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6777);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(369);
/* harmony import */ var redux_global_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3663);
/* harmony import */ var redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8279);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3135);












function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var AppHeader = function(param) {
    var _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().asPath;
    var ref = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_8__/* .useViewport */ .Sj)(), isTwoColumnView = ref.isTwoColumnView, width = ref.width;
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)(), 2), state = ref1[0], configDispatch = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScrolling = ref2[0], setIsScrolling = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowingHamburger = ref3[0], setIsShowingHamburger = ref3[1];
    var currentScreen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_global_slice__WEBPACK_IMPORTED_MODULE_9__/* .selectors.currentScreen */ .wl.currentScreen);
    var eventTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__/* .selectors.eventTitle */ .wl.eventTitle);
    var goToHomePage = function() {
        window.location.href = '/';
    };
    var confirmGoToHomePage = function() {
        if (currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay) {
            configDispatch({
                type: 'SET_CONFIRM_MESSAGE',
                payload: 'Are you sure you want to return to the home page?'
            });
            configDispatch({
                type: 'SHOW_MODAL_CONFIRM',
                payload: true
            });
            configDispatch({
                type: 'SET_CONFIRM_ACTION',
                payload: goToHomePage
            });
        }
    };
    var showModalJoinOuting = function() {
        configDispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    var isEventTitleVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return currentScreen && currentScreen !== utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.Landing */ .wc.Landing && (isTwoColumnView || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay);
    }, [
        isTwoColumnView,
        currentScreen
    ]);
    var toggleNavHamburger = function() {
        setIsShowingHamburger(!isShowingHamburger);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function(e) {
            var offset = window.pageYOffset || document.documentElement.scrollTop;
            if (offset > 0) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var isWhiteNavbar = !transparent || isScrolling || isShowingHamburger;
    var isSmallLogoNeeded = (eventTitle === null || eventTitle === void 0 ? void 0 : eventTitle.length) > 20 && width < 650 && currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'nav_header' + (isWhiteNavbar ? ' white' : ''),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container nav_header_inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "block_left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('header_logo', {
                                    small: isSmallLogoNeeded
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    passHref: true,
                                    href: currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay ? 'javascript:void(0)' : '/',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                        src: isSmallLogoNeeded ? '/images/modal_logo.png' : isWhiteNavbar ? '/images/header/logo_white.png' : '/images/header/logo.png',
                                        alt: "Logo",
                                        layout: "fill",
                                        objectFit: "contain",
                                        onClick: confirmGoToHomePage
                                    })
                                })
                            }),
                            isEventTitleVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "nav_logo_text",
                                children: isSmallLogoNeeded ? "".concat(eventTitle.slice(0, 16), "...") : eventTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "block_right",
                        children: width > 650 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "nav_menu_container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/help-details",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Help & Details"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Contact"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "nav_button",
                                        onClick: showModalJoinOuting,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Create Now"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "arrow_button"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "nav_menu_container",
                            children: isWhiteNavbar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger_grey.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            })
                        })
                    })
                ]
            }),
            width <= 650 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: 'nav_mobile_menu' + (isShowingHamburger ? ' show' : ''),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_shadow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/help-details",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Help & Details"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/contact-us",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Contact"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_button",
                        onClick: showModalJoinOuting,
                        children: "Create Now"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppHeader);


/***/ }),

/***/ 2053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconArrowNext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var IconArrowNext = function(param) {
    var _color = param.color, color = _color === void 0 ? '#FFFFFF' : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "15",
        viewBox: "0 0 9 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.98836 0.292893L8.35232 6.65685C8.74284 7.04738 8.74284 7.68054 8.35232 8.07107L1.98836 14.435C1.59783 14.8256 0.964668 14.8256 0.574143 14.435C0.183619 14.0445 0.183619 13.4113 0.574143 13.0208L5.231 8.36396L6.14551 7.36396L5.231 6.36396L0.574143 1.70711C0.183619 1.31658 0.183619 0.683418 0.574143 0.292893C0.964668 -0.0976311 1.59783 -0.0976311 1.98836 0.292893Z",
            fill: color
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconArrowNext);


/***/ }),

/***/ 2663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "WpPost": function() { return /* binding */ WpPost; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8520);
/* harmony import */ var _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(369);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_app_header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9735);
/* harmony import */ var components_app_footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2695);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1664);
/* harmony import */ var components_icon_arrow_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2053);
/* harmony import */ var utils_dayjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2869);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3135);
/* harmony import */ var styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6322);
/* harmony import */ var styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14__);















function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var __N_SSG = true;
var WpPost = function(param) {
    var posts1 = param.posts, wpTag = param.wpTag, authors = param.authors, wpTagIds = param.wpTagIds, postsMedia = param.postsMedia;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var isMobile = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_5__/* .useViewport */ .Sj)().isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(posts1), wpPosts = ref[0], setWpPosts = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(authors), wpAuthors = ref1[0], setWpAuthors = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(postsMedia), wpMedia = ref2[0], setWpMedia = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), loadMore = ref3[0], setLoadMore = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(1), page1 = ref4[0], setPage = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(2), totalPage = ref5[0], setTotalPage = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(''), keySearch = ref7[0], setKeySearch = ref7[1];
    var firstPostId = posts1.length > 0 ? posts1[0]['id'] : 0;
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var handleScrollLoadMorePost = function() {
            var _documentElement = document.documentElement, scrollTop = _documentElement.scrollTop, scrollHeight = _documentElement.scrollHeight, clientHeight = _documentElement.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - 200) {
                if (page1 <= totalPage && loadMore) {
                    setLoadMore(false);
                    getPostData(page1);
                }
            }
        };
        window.addEventListener('scroll', handleScrollLoadMorePost);
        return function() {
            return window.removeEventListener('scroll', handleScrollLoadMorePost);
        };
    }, [
        loadMore,
        totalPage
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var getPostData = _asyncToGenerator(_vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        return _vercel_path0_node_modules_next_node_modules_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setLoadMore(false);
                    setIsLoading(true);
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_7___default().get("https://wp.boom.tv/index.php/wp-json/wp/v2/posts?categories=14&tags=".concat(wpTagIds, "&exclude=").concat(posts1[0]['id'], "&page=").concat(page, "&per_page=1")).then(function(response1) {
                        setIsLoading(false);
                        setPage(page + 1);
                        var posts = response1.data;
                        setTotalPage(parseInt(response1.headers['x-wp-totalpages']));
                        if (posts.length > 0) {
                            setWpPosts(function(post) {
                                return _toConsumableArray(post).concat(_toConsumableArray(posts));
                            });
                            router.query.slug = posts[0].slug;
                            router.push(router, undefined, {
                                shallow: true
                            });
                            if (!authors[posts[0].author]) {
                                fetch("https://wp.boom.tv/index.php/wp-json/wp/v2/users?include=".concat(authors[posts[0].author])).then(function(response) {
                                    return response.json();
                                }).then(function(result) {
                                    var newAuthor = {
                                    };
                                    newAuthor[result[0].id] = result[0];
                                    setWpAuthors(Object.assign(wpAuthors, newAuthor));
                                });
                            }
                            if (posts[0].featured_media !== 0) {
                                fetch("https://wp.boom.tv/index.php/wp-json/wp/v2/media/".concat(posts[0]['featured_media'])).then(function(response) {
                                    return response.json();
                                }).then(function(result) {
                                    var newMedia = {
                                    };
                                    newMedia[posts[0].id] = result.guid.rendered;
                                    setWpMedia(Object.assign(wpMedia, newMedia));
                                });
                            } else {
                                var newMedia1 = {
                                };
                                newMedia1[posts[0].id] = typeof utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .blogDefaultFeaturedImage */ .RL[wpTag] !== 'undefined' ? utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .blogDefaultFeaturedImage */ .RL[wpTag] : '';
                                setWpMedia(Object.assign(wpMedia, newMedia1));
                            }
                            setTimeout(function() {
                                setLoadMore(true);
                            }, 500);
                        }
                    }).catch(function(error) {
                        setIsLoading(false);
                        console.log(error);
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var handleKeyDown = function(event) {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    var handleChangeKeySearch = function(event) {
        var value = event.target.value;
        setKeySearch(value.trim());
    };
    var handleSearch = function() {
        if (!keySearch) return;
        location.href = '/help-details/search?q=' + keySearch;
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        id: "wpBlog_page",
        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().news_page),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "".concat(wpPosts[0].title.rendered.replace(/(<([^>]+)>)/gi, ''), " | Team Games Blogs")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        href: "/images/modal_logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .TeamGamesMetaDescription */ .iO
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "og:image",
                        content: utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .TeamGamesOGImagePath */ .Od
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_app_header__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        transparent: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg) + (firstPostId && postsMedia[firstPostId] ? ' ' + (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg_ep) : ''),
                        children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                src: "/images/wpTag/background_mobile.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_bg_img),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                src: "/images/wpTag/background.png",
                                alt: "Game for Every Team",
                                layout: "fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_left),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_breadcrumb),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_help),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                                href: "/help-details",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    children: "Help & Details"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_icon_arrow_next__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_wp_tag),
                                            children: wpTag.replace('-', ' ')
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_right),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_search_container),
                                    children: [
                                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_search_icon),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                src: "/images/help_details/search_icon.png",
                                                alt: "Search Icon",
                                                width: 17,
                                                height: 17,
                                                onClick: handleSearch
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_search_border)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_search_input),
                                            placeholder: "Search FAQ, Announcements, etc...",
                                            onKeyDown: handleKeyDown,
                                            onChange: handleChangeKeySearch
                                        }),
                                        isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().header_search_icon_mobile),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                src: "/images/help_details/search_icon_mobile.png",
                                                alt: "Search Icon",
                                                layout: "fill",
                                                onClick: handleSearch
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container) + (firstPostId && postsMedia[firstPostId] ? ' ' + (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container_bg_ep) : ''),
                children: wpPosts.map(function(post, postIndex) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_container),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post),
                                children: [
                                    wpMedia[post.id] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_media),
                                        src: wpMedia[post.id],
                                        alt: "Post Media",
                                        width: 1400,
                                        height: 652
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().main_content),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().main_tag),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                                    href: "".concat(utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .wpRoutePrefix */ ._e, "/").concat(wpTag),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        className: "heading_2 ".concat((styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tags)),
                                                        children: wpTag.replace('-', ' ')
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_title) + ' hero',
                                                dangerouslySetInnerHTML: {
                                                    __html: post.title.rendered
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_body),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_author),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_author_avatar),
                                                                src: wpAuthors[post.author].avatar_urls[96],
                                                                width: 56,
                                                                height: 56,
                                                                alt: "Author Avatar"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "heading_3",
                                                                children: wpAuthors[post.author].name
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: 'heading_4 ' + (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_time),
                                                                children: (0,utils_dayjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(new Date(post.date)).format('MM/DD/YYYY')
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().post_content),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "description_medium",
                                                            dangerouslySetInnerHTML: {
                                                                __html: post.content.rendered
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_title) + ' heading_2',
                                        children: "The Author"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_info),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_avatar),
                                                src: wpAuthors[post.author].avatar_urls[96],
                                                width: 75,
                                                height: 75,
                                                alt: "Author Avatar"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_about),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_name) + ' heading_3',
                                                        children: wpAuthors[post.author].name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().author_section_desc) + ' description_small',
                                                        children: wpAuthors[post.author].description
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (styles_blogPost_module_scss__WEBPACK_IMPORTED_MODULE_14___default().loading_post),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    src: "/images/ellipsis.svg",
                                    alt: "Loading",
                                    layout: "fill"
                                })
                            })
                        ]
                    }, postIndex);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_app_footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (WpPost);


/***/ }),

/***/ 2869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5069);
/* harmony import */ var dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7__);








dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_2___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_objectSupport__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_7___default()));
/* harmony default export */ __webpack_exports__["Z"] = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 6322:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_section":"blogPost_header_section__NPdGD","header_bg":"blogPost_header_bg__SQayc","header_bg_ep":"blogPost_header_bg_ep__9FCGO","header_bg_img":"blogPost_header_bg_img__o0IKa","header_container":"blogPost_header_container__gFrgo","header_left":"blogPost_header_left__j0j5z","header_breadcrumb":"blogPost_header_breadcrumb__tZFq_","header_help":"blogPost_header_help__eTCY_","header_wp_tag":"blogPost_header_wp_tag__GvX5o","header_right":"blogPost_header_right__kxGib","header_search_container":"blogPost_header_search_container__iVT_4","header_search_icon":"blogPost_header_search_icon__1m7Wa","header_search_border":"blogPost_header_search_border__0JdA8","header_search_input":"blogPost_header_search_input__WXi6G","container":"blogPost_container__bERvq","container_bg_ep":"blogPost_container_bg_ep__nwrWe","post_container":"blogPost_post_container__QkKmw","post":"blogPost_post__eiqL5","post_media":"blogPost_post_media__LFlzi","main_content":"blogPost_main_content__QUl7l","main_tag":"blogPost_main_tag__WPCgd","tags":"blogPost_tags__xmVFn","post_title":"blogPost_post_title__QsiD0","post_body":"blogPost_post_body__7iaJ8","post_author":"blogPost_post_author__X2aFx","post_author_avatar":"blogPost_post_author_avatar__yThHr","post_time":"blogPost_post_time__xEvEC","post_content":"blogPost_post_content__tb9d8","author_section":"blogPost_author_section__42W2v","author_section_title":"blogPost_author_section_title__ZsFie","author_section_info":"blogPost_author_section_info__pjmbe","author_section_avatar":"blogPost_author_section_avatar__yGWPi","author_section_about":"blogPost_author_section_about__2m__C","author_section_name":"blogPost_author_section_name__7GRXm","loading_post":"blogPost_loading_post__nfD6_","header_search_icon_mobile":"blogPost_header_search_icon_mobile__cSQb2"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [78,969,774,888,179], function() { return __webpack_exec__(3313); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);